"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToCents = exports.zeroPadding = void 0;
var zeroPadding = function (num, maxLength) { return num
    .toLocaleString(undefined, { minimumIntegerDigits: maxLength, useGrouping: false }); };
exports.zeroPadding = zeroPadding;
var roundToCents = function (val) { return Math.round(val * 100) / 100; };
exports.roundToCents = roundToCents;
